(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auralis-calm-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionId = document.currentScript
    ? document.currentScript.closest('[id^="acr-"]')
    : null;

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.acr[data-section-id]');
    sections.forEach(function (sec) {
      var id = sec.dataset.sectionId;
      initGallery(id);
      initVariants(id);
      initStickyCta(id);
    });
  });

  function initGallery(id) {
    var mainImg = document.getElementById('acr-main-img-' + id);
    if (!mainImg) return;
    var thumbs = document.querySelectorAll('#acr-' + id + ' .acr__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.src;
        if (src) {
          mainImg.src = src;
          thumbs.forEach(function (t) { t.classList.remove('acr__thumb--active'); });
          this.classList.add('acr__thumb--active');
        }
      });
    });
  }

  function initVariants(id) {
    var form = document.getElementById('auralis-form-' + id);
    if (!form) return;
    var variantInput = document.getElementById('acr-variant-' + id);
    var priceEl = document.getElementById('acr-price-' + id);
    var btn = document.getElementById('acr-btn-' + id);
    var stickyBtn = document.getElementById('acr-sticky-btn-' + id);
    var radios = form.querySelectorAll('.acr__radio');
    if (!radios.length) return;

    var productJson = document.getElementById('acr-product-json-' + id);
    if (!productJson) return;

    var product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var selectedOptions = {};
        form.querySelectorAll('.acr__radio:checked').forEach(function (r) {
          selectedOptions[r.dataset.optionPosition] = r.value;
        });

        var selectedVariant = null;
        product.variants.forEach(function (v) {
          var match = true;
          Object.keys(selectedOptions).forEach(function (pos) {
            var optKey = 'option' + pos;
            if (v[optKey] !== selectedOptions[pos]) match = false;
          });
          if (match) selectedVariant = v;
        });

        if (!selectedVariant) return;

        variantInput.value = selectedVariant.id;

        if (priceEl) {
          var compare = selectedVariant.compare_at_price;
          var price = selectedVariant.price;
          var html = '';
          if (compare > price) {
            var pct = Math.round((compare - price) * 100 / compare);
            html += '<span class="acr__price-compare"><s>' + formatMoney(compare) + '</s></span>';
            html += '<span class="acr__price-badge">-' + pct + '%</span>';
          }
          html += '<span class="acr__price-current">' + formatMoney(price) + '</span>';
          priceEl.innerHTML = html;
        }

        var avail = selectedVariant.available;
        [btn, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !avail;
          b.setAttribute('aria-disabled', !avail ? 'true' : 'false');
        });

        var selectedLabels = form.querySelectorAll('[id^="acr-opt-val-"]');
        selectedLabels.forEach(function (lbl) {
          var pos = lbl.id.split('-').pop();
          var key = 'option' + pos;
          if (selectedVariant[key]) lbl.textContent = selectedVariant[key];
        });
      });
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function initStickyCta(id) {
    var mainBtn = document.getElementById('acr-btn-' + id);
    var sticky = document.getElementById('acr-sticky-' + id);
    var stickyBtn = document.getElementById('acr-sticky-btn-' + id);
    if (!mainBtn || !sticky) return;

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('auralis-form-' + id);
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          sticky.classList.add('acr__sticky--visible');
          sticky.removeAttribute('aria-hidden');
        } else {
          sticky.classList.remove('acr__sticky--visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(mainBtn);
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
